const DEFAULT_LAYER_RESULT = {
  layerNumber: 0,
  rateAdequacy: '0',
  exposureFull: '0',
  pinnacleExposure: '0',
  premium: '0',
  lossCost: '0',
  rateOnLine: '0',
  rateOnExposure: '0',
  expectedULR: '0',
  targetedMLR: '0',
  ulrAdequacy: '0',
  returnOnCapital: '0',
  shareOfPremiumNet: '0',
  expectedProfit: '0',
  lineSize: '0',
  shareOfExpectedLossCost: '0',
  premiumNet: '0',
  capitalAllocation: '0',
};

export { DEFAULT_LAYER_RESULT };
